export default __webpack_public_path__ + "static/media/skoda.fce10e37.png";